import React from 'react'
import Backdrop from './Backdrop'

interface ProfileModalProps {
  onClose: () => void
  onOpenGuide: () => void
  onOpenTC: () => void
  userDisplayName?: string
  userSubtitle?: string
  userInitials?: string
  isAdmin?: boolean
  onOpenAdmin?: () => void
}

function Row({
  icon,
  label,
  sub,
  onClick,
  noArrow,
}: {
  icon: string
  label: string
  sub: string
  onClick?: () => void
  noArrow?: boolean
}) {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '11px 0',
        borderBottom: '1px solid var(--bd2)',
        cursor: onClick ? 'pointer' : 'default',
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          const el = e.currentTarget.querySelector('.prl') as HTMLElement | null
          if (el) el.style.color = 'var(--blue)'
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          const el = e.currentTarget.querySelector('.prl') as HTMLElement | null
          if (el) el.style.color = 'var(--text)'
        }
      }}
    >
      <div>
        <div
          className="prl"
          style={{
            fontSize: 13,
            fontWeight: 500,
            color: 'var(--text)',
            transition: 'color .18s',
          }}
        >
          {icon} &nbsp;{label}
        </div>
        <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 1 }}>{sub}</div>
      </div>
      {!noArrow && <span style={{ color: 'var(--muted2)', fontSize: 13 }}>→</span>}
    </div>
  )
}

export default function ProfileModal({
  onClose,
  onOpenGuide,
  onOpenTC,
  userDisplayName = 'User',
  userSubtitle = 'Quantum Leap · Achiever',
  userInitials = 'U',
  isAdmin,
  onOpenAdmin,
}: ProfileModalProps) {
  return (
    <Backdrop onClose={onClose}>
      <div
        style={{
          background: 'var(--white)',
          borderRadius: 20,
          width: 380,
          maxWidth: '94vw',
          boxShadow: 'var(--sh-lg)',
          overflow: 'hidden',
          animation: 'mIn .4s cubic-bezier(.16,1,.3,1) both',
        }}
      >
        <div style={{ background: 'var(--navy)', padding: '22px 22px 18px' }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: 'rgba(255,255,255,.12)',
              border: '2px solid rgba(255,255,255,.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 17,
              fontWeight: 600,
              color: 'var(--white)',
              marginBottom: 11,
            }}
          >
            {userInitials}
          </div>
          <h3
            style={{
              fontFamily: "'Playfair Display',serif",
              fontSize: 17,
              fontWeight: 500,
              color: 'var(--white)',
            }}
          >
            {userDisplayName}
          </h3>
          <p style={{ fontSize: 11.5, color: 'rgba(255,255,255,.45)', marginTop: 3 }}>
            {userSubtitle}
          </p>
        </div>
        <div style={{ padding: '16px 20px 20px' }}>
          {isAdmin && onOpenAdmin && (
            <Row
              icon="🛡"
              label="Admin Panel"
              sub="Manage users and settings"
              onClick={() => {
                onClose()
                onOpenAdmin()
              }}
            />
          )}
          <Row
            icon="✦"
            label="Guides"
            sub="How to use Athena effectively"
            onClick={() => {
              onClose()
              onOpenGuide()
            }}
          />
          <Row
            icon="⚖️"
            label="Terms of Use"
            sub="Athena — usage terms"
            onClick={() => {
              onClose()
              onOpenTC()
            }}
          />
          <Row icon="" label="Version" sub="Athena · Beta v0.1" noArrow />
        </div>
      </div>
    </Backdrop>
  )
}
